const group = {
  id: 0,
  name: '',
  active: false,
  created_at: '',
  updated_at: ''
}

export default group
